const head_set_meta = (meta) => {
	if (!meta) return;
	try {
		const html = document.getElementsByTagName("html")[0];
		if (!html) return;
		const head = html.getElementsByTagName("head")[0];
		if (!head || !head.children) return;

		for (var i = 0; i < head.children.length; i++) {
			const child = head.children[i];
			const attr = child.attributes;

			if (child.nodeName === "META") {
				var prop = attr.getNamedItem("property");
				if (prop && prop.name === "property") {
					if (prop.value === "og:title") {
						child.setAttribute("content", meta.Title);
					} else if (prop.value === "og:description") {
						child.setAttribute("content", meta.Description);
					}
				}
				prop = attr.getNamedItem("name");
				if (prop && prop.name === "name") {
					if (prop.value === "description") {
						child.setAttribute("content", meta.Description);
					}
				}
			} else if (child.nodeName === "TITLE") {
				child.innerHTML = meta.Title;
			}

		}
	} catch (e) {
		console.log(e);
	}
};

export {
	head_set_meta
}



// WEBPACK FOOTER //
// ./src/head.js